import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircleIcon, AlertTriangleIcon } from 'lucide-react';
const painPoints = [<>
    Viven en <strong data-id="element-241">"Cese de Fuego"</strong> o <em data-id="element-242">"Guerra Fría"</em>{' '}
    constante.
  </>, <>
    Se sienten más como <strong data-id="element-243">"Compañeros de Cuarto"</strong> que como pareja.
  </>, <>
    Sienten que están al <strong data-id="element-244">borde de la separación</strong>.
  </>, <>
    Sufren de <em data-id="element-245">Agotamiento Emocional</em> extremo.
  </>, <>
    Viven con <strong data-id="element-246">resentimiento acumulado</strong> por discusiones pasadas.
  </>, <>
    Quieren salvar la pareja pero <strong data-id="element-247">no saben por dónde empezar</strong>.
  </>];
const benefits = [<>
    ✔ <strong data-id="element-248">Herramientas prácticas</strong> para aplicar en los próximos 7
    días.
  </>, <>
    ✔ <strong data-id="element-249">Protocolo de comunicación</strong> para hablar sin terminar en
    peleas.
  </>, <>
    ✔ Ejercicios guiados de <em data-id="element-250">reconexión emocional</em>.
  </>, <>
    ✔ Guía paso a paso para <strong data-id="element-251">sanar heridas del pasado</strong>.
  </>, <>
    ✔ Estrategias para <strong data-id="element-252">blindar la relación</strong> contra crisis
    externas.
  </>];
export function TargetAudienceSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#110038] relative" data-id="element-253">
      <div className="max-w-6xl mx-auto px-6" data-id="element-254">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-255">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: -30
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-256">
            <div className="inline-block bg-[#E5A83B]/20 text-[#E5A83B] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-6" data-id="element-257">
              ¿TE SUENA FAMILIAR?
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 font-serif leading-tight" data-id="element-258">
              Este material es urgente para vos si:
            </h2>
            <ul className="space-y-5" data-id="element-259">
              {painPoints.map((point, index) => <li key={index} className="flex items-start gap-3" data-id="element-260">
                  <AlertTriangleIcon className="w-6 h-6 text-[#E5A83B] flex-shrink-0 mt-0.5" data-id="element-261" />
                  <span className="text-[#C4B5FD] text-lg font-sans leading-snug" data-id="element-262">
                    {point}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: 30
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="bg-[#0D002B] rounded-2xl p-8 md:p-10 border border-[#7C3AED]/30 shadow-[0_10px_30px_-10px_rgba(124,58,237,0.2)] relative overflow-hidden" data-id="element-263">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#34D399] to-[#059669]" data-id="element-264"></div>
            <h3 className="text-2xl font-bold text-white mb-6 font-serif" data-id="element-265">
              Lo que vas a lograr{' '}
              <span className="text-[#34D399]" data-id="element-266">hoy mismo</span>:
            </h3>
            <ul className="space-y-5" data-id="element-267">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-268">
                  <span className="text-white font-medium font-sans text-lg leading-snug" data-id="element-269">
                    {benefit}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}